import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
// import {MatSort, MatTableDataSource} from '@angular/material';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit, OnDestroy {

  @Input()
  header = [];

  private _data = [];

  @Input()
  displayedColumns: string[] = []   ;

  dataSource;

  @Input()
  startInterval = false;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  private interval;

  @Output()
  editItem = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.updateTable();
    if (this.startInterval) {
      this.interval = setInterval(() => {
        this.updateTable();
      }, 1000);
    }
    else{
      this.dataSource = new MatTableDataSource(this._data);
      this.dataSource.sort = this.sort;
    }
  }

  ngOnDestroy(): void {
    if(this.startInterval) {
      clearInterval(this.interval);
    }
  }

  get data(): any[] {
    return this._data;
  }

  @Input()
  set data(value: any[]) {
    this.dataSource = new MatTableDataSource(value);
    this._data = value;
  }

  updateTable(){
    this.dataSource = new MatTableDataSource(this._data);
    this.dataSource.sort = this.sort;
  }

  getDataSource(){
    return this.dataSource;
  }

  getDefName(head): string {
    return head.defName;
  }

  edit(item) {
    this.editItem.emit(item);
  }

}
